// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3Gbhw","clinicsSelect":"TableHeading_clinicsSelect__3G_WH"};